import React from "react";
import { Outlet } from "react-router-dom";
import { DashboardLayout } from "../components/Layouts/DashboardLayout";
import { ToastContainer } from "react-toastify";
import ReviewCard from "../components/Cards/ReviewCard";
import { useAuthContext } from "../context/authContext";

export const Dashboard = () => {
  const { state: authState } = useAuthContext();
  return (
    <>
      <DashboardLayout>
        <Outlet />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop
          closeOnClick
          draggable
          pauseOnHover
          closeButton={false}
          className="!w-auto !max-w-sm"
          toastClassName={({ type }) =>
            `relative flex items-center p-3 rounded-lg shadow-md mb-4 border-l-4 transition-all
     ${
       type === "success"
         ? "bg-green-100 text-green-900 border-l-green-500"
         : type === "error"
           ? "bg-red-100 text-red-900 border-l-red-500"
           : "bg-gray-50 text-gray-800 border-l-gray-300"
     }`
          }
          bodyClassName="text-sm font-medium"
        />
        <ReviewCard shouldShowReviewPrompt={authState?.me?.showRatingPrompt} />
      </DashboardLayout>
    </>
  );
};
